import React from "react";

const EmptyPage = (props) => {

    return (
        <div style={{textAlign:'center', width:'100%'}}>
            <h1 style={{fontWeight:'bold', opacity:0.6}}>{props.title}</h1>
            <h3 style={{fontWeight:'300', opacity:0.6}} className="mt-3">{props.subtitle}</h3>
            <h3 style={{fontWeight:'300', opacity:0.6}}>{props.subsubtitle}</h3>
        </div>
    );
}


export default EmptyPage;
